import React from 'react'
import { connect } from 'react-redux'

import { IMPORT_FILES } from 'components/Utils/Modal/constants'
import { getOtherOrganizationAppURL, getRootURL } from 'helpers/URLHelper'
import { fetchJoinedOrganizations } from 'data/organizations/actions'
import {
  getOrganization,
  getJoinedOrganizations,
} from 'data/organizations/selectors'
import { signOut } from 'data/auth/actions'
import { setActiveModal, goToOrganizationUpgrade } from 'data/ui/actions'
import { selectors as UsersSelectors } from 'data/users'
import { selectors as ConfigSelectors } from 'data/config'

import Dropdown from 'components/base/Dropdown'
import Avatar from 'components/Utils/Avatar'
import { TooltipOnHover } from 'components/Utils/TooltipOnHover'
import getBodyEntries from './getBodyEntries'
import OrganizationResourcesUsageItem from './OrganizationResourcesUsageItem'
import IfPaidPlan from 'components/Utils/IfPaidPlan'
import history from 'browserHistory'

const enhance = connect(
  state => {
    return {
      organization: getOrganization(state),
      user: UsersSelectors.getCurrentUser(state),
      joinedOrganizations: getJoinedOrganizations(state),
      canManage: UsersSelectors.canCurrentUserManageOrganization(state),
      canManageBilling: UsersSelectors.canCurrentUserManageOrganizationBilling(
        state
      ),
      canInvite: UsersSelectors.canCurrentUserInviteMembers(state),
      currentUserIsGuest: UsersSelectors.isCurrentUserGuest(state),
      desktopDownloadURL: ConfigSelectors.getDesktopDownloadUrl(state),
    }
  },
  {
    openImportModal: () => setActiveModal({ id: IMPORT_FILES }),
    fetchJoinedOrganizations,
    signOut,
    goToOrganizationUpgrade,
  }
)

export default enhance(function OrganizationDropdownBody({
  organization,
  user,
  joinedOrganizations,
  signOut,
  canManage,
  canManageBilling,
  canInvite,
  desktopDownloadURL,
  openImportModal,
  goToOrganizationUpgrade,
  fetchJoinedOrganizations,
  currentUserIsGuest,
}) {
  React.useEffect(function onMount() {
    fetchJoinedOrganizations() // check domain on init
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const entries = getBodyEntries({
    organization,
    user,
    desktopDownloadURL,
    joinedOrganizations,
    canManage,
    canManageBilling,
    canInvite,
    getRootURL,
    getOtherOrganizationAppURL,
    signOut,
    openImportModal,
    goToOrganizationUpgrade,
    currentUserIsGuest,
  })
  return (
    <Dropdown.Body placement="bottom-left" style={{ top: '140%', zIndex: 2 }}>
      <div className="scrollable" style={{ maxHeight: 'calc(100vh - 120px)' }}>
        {entries
          .filter(entry => entry.isAllowed !== false)
          .map((entry, index) => {
            switch (entry.type) {
              case 'header':
                return (
                  <Dropdown.Header key={index}>
                    <div className="flexbox shade-05">
                      <div className="flexbox-no-grow padding-right-normal">
                        <Avatar url={entry.photoURL} name={entry.title} />
                      </div>
                      <div className="flexbox-grow">
                        <div className="bold">{entry.title}</div>
                        <div className="shade-20">{entry.subtitle}</div>
                      </div>
                      {entry.withAction && (
                        <TooltipOnHover
                          id={`orgnization-dropdown-${index}`}
                          placement="right"
                          tooltipContent={entry.withAction.tooltip}
                        >
                          <div
                            onClick={entry.withAction.action}
                            className="flexbox-no-grow padding-vertical-small padding-horizontal-medium pointer shade-20 shade-10-on-hover"
                          >
                            <entry.withAction.icon />
                          </div>
                        </TooltipOnHover>
                      )}
                    </div>
                  </Dropdown.Header>
                )
              case 'divider':
                return (
                  <Dropdown.Divider key={index}>{entry.title}</Dropdown.Divider>
                )
              case 'button':
                return (
                  <Dropdown.Button key={index} onClick={entry.action}>
                    {entry.title}
                  </Dropdown.Button>
                )
              case 'item':
                return (
                  <Dropdown.Item
                    key={index}
                    icon={
                      entry.avatarName ? (
                        <Avatar url={entry.avatar} name={entry.avatarName} />
                      ) : (
                        <entry.icon size={16} />
                      )
                    }
                    subtitle={entry.subtitle}
                    onClick={() => {
                      entry.to ? history.push(entry.to) : entry.action()
                    }}
                  >
                    {entry.title}
                  </Dropdown.Item>
                )
              case 'note-usage':
                return (
                  <IfPaidPlan key={index} show={false}>
                    <OrganizationResourcesUsageItem
                      key={index}
                      icon={<entry.icon size={16} />}
                      title={entry.title}
                      action={entry.action}
                    />
                  </IfPaidPlan>
                )
              default:
                return false
            }
          })}
      </div>
    </Dropdown.Body>
  )
})
